import req from './index'

// 人员

//获取风险处理员列表
export const GetHandlerUserList = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.RiskHandlerUser_List', params)
}

//获取风险处理员详细信息
export const GetHandlerUserInfo = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.RiskHandlerUser_Info', params)
}

//风险处理员更新或添加
export const SetHandlerUser = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RiskHandlerUser_Set', params)
}

// 风险处理员状态更新
export const SetState = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RiskHandlerUser_Status', params)
}


// 组队

// 获取 处理人员数据
export const getHandlerListFun = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.UserGroup_Get', params)
}

// 获取 处理人员数据
export const getTeamListFun = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.UserGroupStr_Get', params)
}

// 新增 | 编辑组队
export const setTeamFun = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.UserGroup_Add', params)
}

// 组队分配人员
export const teamAssignPersonnelFun = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.UserGroup_Set', params)
}

// 解散组队
export const delTeamFun = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.userGroup_Del', params)
}